// extracted by mini-css-extract-plugin
export var carousal = "index-module--carousal--NSAz0";
export var carousalImageContainer = "index-module--carousalImageContainer--O-uRy";
export var container = "index-module--container--b28H0";
export var gradBorder = "index-module--gradBorder--mdANR";
export var joinUsButton = "index-module--joinUsButton--b-WPa";
export var subtitle = "index-module--subtitle--m5dbi";
export var textBox = "index-module--textBox--G0LGS";
export var title = "index-module--title--2yUs1";